<!--
 * @Author: Yran
 * @Date: 2021-11-26 11:52:31
 * @LastEditors: Yran
 * @LastEditTime: 2021-12-13 16:05:07
-->
<template>
  <a-modal v-model:visible="addTempVisible.visible" class="add-temp-modal" centered title="规则模板" width="1182px" :footer="null">
    <a-spin :spinning="spinning">
      <div class="temp-list">
        <div class="temp-box temp-null-box">
          <FileTextOutlined style="font-size: 42px; color: #b8b8b8" />
          空白模板
          <!-- 请不要删除括号 -->
          <div class="temp-box-create" @click="gotoEditPage(null)">开始创建</div>
        </div>
        <div class="temp-box" v-for="(temp, index) in tempList" :key="index">
          <p class="temp-box-title">{{ temp.ruleName }}</p>
          <div class="temp-box-condition flex" v-if="temp.tempObj">
            <div class="temp-box-label">条件：</div>
            <div class="temp-box-text">
              <p v-for="(condition, conditionIndex) in temp.tempObj.condition" :key="conditionIndex">{{ condition }}</p>
            </div>
          </div>
          <div class="temp-box-operate flex" v-if="temp.tempObj">
            <div class="temp-box-label">操作：</div>

            <div class="temp-box-text">
              <p v-for="(operate, operateIndex) in temp.tempObj.operate" :key="operateIndex">{{ operate }}</p>
            </div>
          </div>
          <div class="temp-box-create" @click="gotoEditPage(temp)">开始创建</div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
import { getRuleStstemList } from '@/api/hosting/index.js';
export default {
  emits: ['getTempData'],
  inject: ['addTempVisible', 'showCustomizeRule'],
  data() {
    return {
      tempList: [],
      spinning: false,
    };
  },
  watch: {
    'addTempVisible.visible'(newVal) {
      newVal && this.getRuleTempList();
    },
  },
  mounted() {},
  methods: {
    gotoEditPage(temp) {
      if (temp) {
        this.showCustomizeRule.mode = 'copy';
      } else {
        this.addTempVisible.visible = false;
        this.showCustomizeRule.mode = 'add';
        this.showCustomizeRule.visible = true;
      }
      temp && this.$emit('getTempData', temp);
    },
    async getRuleTempList() {
      const postData = {};
      const conditionObj = {
        EQ: '等于',
        LT: '小于',
        GT: '大于',
        LTE: '小于等于',
        GTE: '大于等于',
        NOTIN: '不包含',
        IN: '包含',
      };
      const referenceValueObj = {
        1: '上调',
        2: '下降',
        3: '增加',
        4: '减少',
        5: '调整至消耗',
        6: '调整至',
        7: '开启',
        8: '暂停',
        9: '仅通知',
        10: '调整至次日',
      };
      const valueTypeDict = { RMB: '元', '%': '%' };
      this.spinning = true;
      let res = await getRuleStstemList(postData);
      if (res.code == 0 && res.data && res.data.list) {
        res.data.list.forEach(item => {
          const condition = item.condition && JSON.parse(item.condition);
          const conditionArr = [];
          const operate = item.execContent && JSON.parse(item.execContent);
          const operateArr = [];
          condition?.info?.forEach(childItem => {
            conditionArr.push(childItem.fieldName + conditionObj[childItem.condition] + (!childItem.targetFieldName || childItem.targetFieldName == childItem.fieldName ? '' : childItem.targetFieldName) + (childItem.value || 0) + (valueTypeDict[childItem.valueType] || ''));
          });
          operate?.forEach(childItem => {
            const limitValue = !Array.isArray(childItem.limitValue) ? childItem.limitValue.split(',') : childItem.limitValue;
            const limitValueStr = limitValue.length == 2 ? (limitValue?.[0] || 0) + (valueTypeDict[childItem.valueType] || '') + ' ~ ' + (limitValue?.[1] || 0) + (valueTypeDict[childItem.valueType] || '') : limitValue?.[0] || 0;
            operateArr.push(childItem.fieldName + referenceValueObj[childItem.referenceValue] + limitValueStr);
          });
          item.tempObj = {
            condition: conditionArr,
            operate: operateArr,
          };
        });
      }
      this.tempList = res.data?.list;
      this.spinning = false;
    },
  },
};
</script>
<style lang="less" scoped>
.add-temp-modal {
  .temp-list {
    display: flex;
    flex-wrap: wrap;
    max-height: 588px;
    overflow-y: auto;
    .temp-box {
      width: 360px;
      height: 180px;
      border-radius: 4px;
      background: #fcfeff;
      border: 1px solid #bedeff;
      margin-right: 24px;
      margin-top: 24px;
      cursor: pointer;
      position: relative;
      padding: 20px 24px;
      &-title {
        font-size: 16px;
        letter-spacing: 0.01px;
        color: #333;
        margin-bottom: 18px !important;
      }
      &-label {
        font-size: 12px;
        letter-spacing: 0.01px;
        color: #999;
      }
      &-text {
        font-size: 12px;
        letter-spacing: 0.01px;
        color: #666;
      }
      &-condition {
        margin-bottom: 18px;
      }
      &-create {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 36px;
        background: #dfedff;
        color: #2f70f4;
        display: none;
        justify-content: center;
        align-items: center;
      }
      &:hover {
        background: #f9fdff;
      }
      &:hover .temp-box-create {
        display: flex;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
      &:nth-child(-n + 3) {
        margin-top: 0;
      }
    }
    .temp-null-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #666;
      font-size: 12px;
    }
  }
}
</style>
